export enum PointQueryKeys {
  GET_POINT_TRANSACTIONS = 'GET_POINT_TRANSACTIONS',
  GET_QRCODE_GALAXY_PAY = 'GET_QRCODE_GALAXY_PAY',
}
